var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10",
    stroke: "#5B595C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 21V15C14.833 14.4696 14.6223 13.9609 14.2472 13.5858C13.8721 13.2107 13.3634 13 12.833 13H10.833C10.3026 13 9.79387 13.2107 9.41879 13.5858C9.04372 13.9609 8.83301 14.4696 8.83301 15V21",
    stroke: "#5B595C",
    strokeWidth: 1.25,
    strokeMiterlimit: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.818 9.364L20.124 3.435C20.0881 3.30965 20.0124 3.19939 19.9083 3.1209C19.8042 3.04241 19.6774 2.99997 19.547 3H15.5L15.975 8.704C15.9822 8.79572 16.0112 8.8844 16.0595 8.96267C16.1079 9.04094 16.1742 9.10653 16.253 9.154C16.643 9.387 17.405 9.817 18 10C19.016 10.313 20.5 10.2 21.346 10.096C21.4282 10.0854 21.5072 10.0569 21.5773 10.0126C21.6474 9.96835 21.707 9.9093 21.752 9.8396C21.7969 9.7699 21.8261 9.69123 21.8375 9.60909C21.8489 9.52695 21.8423 9.44331 21.818 9.364Z",
    stroke: "#5B595C",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 10C14.5678 9.825 15.2878 9.426 15.6898 9.188C15.7835 9.13222 15.8595 9.05108 15.9091 8.95393C15.9586 8.85678 15.9797 8.7476 15.9698 8.639L15.4998 3H8.4998L8.0298 8.639C8.01974 8.74777 8.0407 8.85716 8.09025 8.9545C8.13981 9.05184 8.21593 9.13315 8.3098 9.189C8.7118 9.426 9.4318 9.825 9.9998 10C11.4928 10.46 12.5068 10.46 13.9998 10Z",
    stroke: "#5B595C",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87556 3.435L2.18156 9.365C2.15765 9.44418 2.15126 9.52762 2.16283 9.60951C2.1744 9.69141 2.20366 9.76981 2.24857 9.83927C2.29348 9.90873 2.35296 9.96758 2.4229 10.0117C2.49284 10.0559 2.57155 10.0843 2.65356 10.095C3.49856 10.2 4.98356 10.312 5.99956 10C6.59456 9.817 7.35756 9.387 7.74656 9.155C7.8255 9.10743 7.89192 9.04168 7.94028 8.96323C7.98864 8.88477 8.01754 8.79589 8.02456 8.704L8.49956 3H4.45256C4.32219 2.99997 4.19534 3.04241 4.09124 3.1209C3.98713 3.19939 3.91142 3.30965 3.87556 3.435Z",
    stroke: "#5B595C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.4c3c257f2c67b3cd42e22a98a8db73e8.svg";
export { ForwardRef as ReactComponent };